import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60, // 1 hour
      gcTime: 1000 * 60 * 60, // 1 hour
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 3
    }
  }
})

export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    // const persister = createAsyncStoragePersister({
    //   storage: window.localStorage,
    //   key: 'tanstack:scms',
    //   throttleTime: 1000
    // })
    // persistQueryClient({
    //   queryClient: queryClient as AllowedAny,
    //   persister,
    //   maxAge: 24 * 60 * 60 * 1000,
    //   buster: 'v1.1' // Todo: Add versioning to bust the cache when needed
    // })
  }

  useNuxtApp().vueApp.use(VueQueryPlugin, { queryClient })
})

export { queryClient }
